import React from 'react'
import { Link } from 'react-router-dom'

const SubscriptionHeader = ({ currentPlan }) => {
	const isTrial = currentPlan?.subscriptions?.status === 'trial'
	const title = isTrial ? 'Current subscription plan' : 'Current plan'

	return (
		<h2
			style={{
				fontSize: '16px',
				fontWeight: 600,
				lineHeight: 1.2,
				marginBottom: 10,
				marginTop: 0,
				color: 'rgba(51, 51, 51, 1)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
			}}
		>
			{title}
			{isTrial ? (
				<Link className='Polaris-Link' to='/subscription'>
					Details
				</Link>
			) : (
				<Link className="manage-link" to="/subscription" style={{ textDecoration: 'none' }}>
					<span style={{ color: 'rgba(38, 127, 215, 1)', textDecoration: 'none' }}>Manage</span>
				</Link>
			)}
		</h2>
	)
}

export default SubscriptionHeader

